class RecallCommunication {
    public Id: string;
    public RecallId: string;
    public Notes: string;
    public DateCreated: string;
    public StateLookupId: string;
    public ContactId: string;
}

export { RecallCommunication };
